import { render, staticRenderFns } from "./BundleCardProductLayout.vue?vue&type=template&id=e1110566&scoped=true"
import script from "./BundleCardProductLayout.vue?vue&type=script&lang=js"
export * from "./BundleCardProductLayout.vue?vue&type=script&lang=js"
import style0 from "./BundleCardProductLayout.vue?vue&type=style&index=0&id=e1110566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1110566",
  null
  
)

export default component.exports